module.exports = __webpack_public_path__ + "img/g1.9f64b3e9.jpg";